import { Box, Center, Heading, Spinner, useToast } from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import ProfileContext from '../context/ProfileContext';
import SelectedGameContext from '../context/SelectedGameContext';
import { LicenseCreationParams, LicenseForm } from '../forms/LicenseForm';

// TODO abstract this and CreateGame into common component
export const UpdateGame: React.FC<{}> = () => {
    const { keycloak } = useKeycloak();
    const profileContext = useContext(ProfileContext);
    const navigate = useNavigate();
    const toast = useToast();
    const selectedGame = useContext(SelectedGameContext);
    const currLicense = selectedGame?.currLicense;

    const updateGameLicense = async (params: LicenseCreationParams) => {
        const resp = await fetch(`${config.licenseServiceURL}/license/${currLicense.key}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
            body: JSON.stringify({
                expiresAt: '2030-12-28T00:00:00.000Z',
                configs: {
                    name: params.name,
                },
                distributionInfo: params.distInfo,
            }),
        });
        if (resp.status !== 200) {
            return toast({
                title: 'There was an error',
                description: 'Please try updating the game again.',
                status: 'error',
                duration: 9000,
                isClosable: true,
            });
        }
        toast({
            title: 'Success!',
            description: 'Game has been updated.',
            status: 'success',
            duration: 9000,
            isClosable: true,
        });
        const json = await resp.json();
        profileContext.licenses[json.data.key] = json.data;
        // Force refresh token to get a new token containing the new license
        await keycloak.updateToken(-1);
        navigate(`/game/${json.data.key}/overview`);
    };

    const renderUpdateSection = () => (
        <>
            <Box marginTop="4em">
                <Heading>Update Game</Heading>
                <LicenseForm
                    initialName={currLicense?.configs?.name}
                    initialDistChannel={currLicense?.distributionInfo?.steamAppID ? 'steam' : ''}
                    initialSteamAppID={currLicense?.distributionInfo?.steamAppID}
                    initialSteamPartnerKey={currLicense?.distributionInfo?.steamPartnerKey}
                    initialAppStoreSecret={currLicense?.distributionInfo?.appStoreSecret}
                    initialPlayStoreKey={currLicense?.distributionInfo?.playStoreKey}
                    initialTwitchClientID={currLicense?.distributionInfo?.twitchClientID}
                    initialTwitchClientSecret={currLicense?.distributionInfo?.twitchClientSecret}
                    onSubmit={updateGameLicense}
                />
            </Box>
        </>
    );

    return (
        <Box width="50%" margin={'0 auto'}>
            {currLicense ? (
                renderUpdateSection()
            ) : (
                <Center width="100%" height="100%">
                    <Spinner data-cy="loading" />
                </Center>
            )}
        </Box>
    );
};
